// extracted by mini-css-extract-plugin
module.exports = {"enableClose":"poscon-module--enableClose--345p1"};